module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"review_policy":"評價運營方式"}}')
  delete Component.options._Ctor
}
